import React, { Fragment, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_POESIA } from '../../graphql/actions/poesia';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';

import sectionFullDataStyle from '../../assets/jss/coscef/views/articuloSections/sectionDetailsStyle';

const useStyles = makeStyles(sectionFullDataStyle);

const PoesiaDetails = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();

  const {
    loading: loadingPoesia,
    error: errorPoesia,
    data: dataPoesia,
  } = useQuery(GET_POESIA, {
    variables: {
      id: props.match.params.id,
    },
    skip: !props.match.params.id,
    errorPolicy: 'all',
  });

  let seccionPoesia = null;
  let showNotification = null;

  if (loadingPoesia) {
    seccionPoesia = (
      <div className={classes.container}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />;
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorPoesia) {
    seccionPoesia = (
      <div className={classes.container}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Error buscando la poesía.</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    showNotification = errorPoesia.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorPoesia ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataPoesia && dataPoesia.getPoesia) {
    const { getPoesia } = dataPoesia;
    //console.log(getPoesia);
    seccionPoesia = (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={8} md={8} key={getPoesia._id}>
          <h3 className={classes.title}>{getPoesia.titulo}</h3>
          <p>Por {getPoesia.autor}</p>
          <div dangerouslySetInnerHTML={{ __html: getPoesia.contenido }}></div>
        </GridItem>
      </GridContainer>
    );
  }

  return (
    <Fragment>
      <div className={classes.main} id='main-panel'>
        <div className={classes.container}>
          <div className={classes.section}>{seccionPoesia}</div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default PoesiaDetails;
